export const AUTH_TOASTS = {
  SIGN_UP_WITH_INVITE_COMPLETE: 'You successfully signed up with your invitation! Sign in to continue.',
  PASSWORD_RESET: 'Your password has sucessfully been reset',
};
